import { Box, styled } from '@mui/material'

export const DaysContainer = styled(Box)({
    display: 'grid',
    gap: '2px',
    gridTemplateColumns: 'repeat(7, 40px)'
})